import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Ripple } from "primereact/ripple";
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import NoDataCreated from "../../../../../Components/NoDataCreated";
import DocumentViewModal from "../../../../../Components/DocumentViewModal";
import Textarea from "../../../../../Components/TextArea";
import ErrorPage from "../../../../../Components/ErrorPage";
import { goToTop } from "../../../../../Components/goToTop";
import TextInput from "../../../../../Components/TextInput";
import { DischargeConditionFollowup, DischargeConditions } from "../../../../../Controllers/Types/Project/DefaultService/DischargeConditionInterface";
import { checkEmail, checkPhoneNumber, checkText } from "../../../../../Utils/Validator";
import { dischargeConditionContactDetailCreateUpdateAPI, dischargeConditionContactDetailDeleteAPI, dischargeConditionFollowupCreateAPI, dischargeConditionFollowupDeleteAPI, dischargeConditionFollowupUpdateAPI } from "../../../../../Api/Project/DefaultServices/DischargeConditionApi";
import { fetchAllDischargeConditionAfterView } from "../../../../../Controllers/Thunks/DischargeConditionThunks";
import { useAppDispatch, useAppSelector } from "../../../../../Controllers/hooks";
import { baseURL } from "../../../../../Api/ApiConstant";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../Controllers/Store";
import { hasPermission } from "../../../../../Controllers/Selectors/permissionsSelector";
import TableActionLoader from "../../../../../Components/TableActionLoader";
import PageLoader from "../../../../../Components/PageLoader";
import { setSelectedDischargeCondition } from "../../../../../Controllers/Slices/DischargeConditionSlice";

const DischargeConditionDetail: React.FC = () => {
    const dispatch = useAppDispatch();
    const selectedDischargeCondition = useAppSelector((state) => state?.dischargeCondition?.selectedDischargeCondition);

    const location = useLocation();
    const dischargeConditionData: DischargeConditions | null = location.state?.dischargeConditionData;
    const projectData = location.state?.projectData;
    const serviceId = Number(projectData.folder_id);
    // const isShared: boolean = projectData.sharedBy !== null ? true : false;
 const isShared: boolean = projectData.can_edit===false ? true : false;

    const loadingPage = useAppSelector((state) => state?.dischargeCondition?.loading);
    const error = useAppSelector((state) => state?.dischargeCondition?.error);

    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const [dataState, setDataState] = useState<'Add' | 'Edit'>('Add');
    const [loading, setLoading] = useState<boolean>(false);

    const [showDocumentViewModal, setShowDocumentViewModal] = useState(false);
    const [drawingFileUrl, setDrawingFileUrl] = useState<string>('');


    /* For case officer detail  */
    const [showCaseOfficerDetailModal, setShowCaseOfficerDetailModal] = useState<boolean>(false);
    const [caseOfficerName, setCaseOfficerName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [contact, setContact] = useState<string>('');
    const [caseOfficerNameError, setCaseOfficerNameError] = useState<string>('');
    const [emailError, setEmailError] = useState<string>('');
    const [contactError, setContactError] = useState<string>('');
    const [caseOfficerDetailUpdateHasChanges, setCaseOfficerDetailUpdateHasChanges] = useState<boolean>(false);
    const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

    /* For followup  */
    const [showFollowupModal, setShowFollowupModal] = useState<boolean>(false);
    const [followupNote, setFollowupNote] = useState<string>('');
    const [selectedFollowupId, setSelectedFollowupId] = useState<number | null>(null);
    const [selectedFollowupData, setSelectedFollowupData] = useState<DischargeConditionFollowup | null>(null);
    const [errorFollowupNote, setErrorFollowupNote] = useState<string>('');
    const [followUpUpdateHasChanges, setFollowUpUpdateHasChanges] = useState<boolean>(false);
    const [followUpDeleteLoadingId, setFollowUpDeleteLoadingId] = useState<number | null>(null);

    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermission_add_follow_up = useCanEdit('Discharge Condition', 'add_follow_up');
    const isPermission_edit_follow_up = useCanEdit('Discharge Condition', 'edit_follow_up');
    const isPermission_delete_follow_up = useCanEdit('Discharge Condition', 'delete_follow_up');

    const isPermission_add_case_officer = useCanEdit('Discharge Condition', 'add_case_officer');
    const isPermission_edit_case_officer = useCanEdit('Discharge Condition', 'edit_case_officer');
    const isPermission_delete_case_officer = useCanEdit('Discharge Condition', 'delete_case_officer');

    /* ******************************** state data call ******************************************* */
    useEffect(() => {
        if (dischargeConditionData) {
            dispatch(setSelectedDischargeCondition(dischargeConditionData));
        }
    }, [dischargeConditionData, location.state]);

    const dischargeConditionDataGet = async () => {
        if (serviceId) {
            dispatch(fetchAllDischargeConditionAfterView(serviceId));
        }
    }
    /* ******************************** state data call ******************************************* */

    /* ******************************* For case officer detail ******************************* */

    useEffect(() => {
        if (selectedDischargeCondition) {
            if (caseOfficerName && caseOfficerName !== selectedDischargeCondition?.case_officer_name) {
                setCaseOfficerDetailUpdateHasChanges(true);
            } else if (email && email !== selectedDischargeCondition?.email) {
                setCaseOfficerDetailUpdateHasChanges(true);
            } else if (contact && contact !== selectedDischargeCondition?.contact_no) {
                setCaseOfficerDetailUpdateHasChanges(true);
            } else {
                setCaseOfficerDetailUpdateHasChanges(false);
            }
        }
    }, [selectedDischargeCondition, caseOfficerName, email, contact]);

    const handleAddCaseOfficerDetail = () => {
        setDataState('Add');
        setShowCaseOfficerDetailModal(true);
    }

    const handleClearCaseOfficerFields = () => {
        setCaseOfficerName('');
        setEmail('');
        setContact('');
    }

    const handleClearCaseOfficerErrors = () => {
        setCaseOfficerNameError('');
        setEmailError('');
        setContactError('');
    }

    const handleEditCaseOfficerDetail = () => {
        setShowCaseOfficerDetailModal(true);
        setDataState('Edit');

        if (selectedDischargeCondition) {
            setCaseOfficerName(selectedDischargeCondition.case_officer_name || '');
            setEmail(selectedDischargeCondition.email || '');
            setContact(selectedDischargeCondition.contact_no || '');
        }
    }

    const handleCloseCaseOfficerDetailModal = () => {
        setShowCaseOfficerDetailModal(false);
        handleClearCaseOfficerFields();
        handleClearCaseOfficerErrors();
    }

    /* Clear error messages */
    useEffect(() => {
        checkText(caseOfficerName, false, setCaseOfficerNameError);
    }, [caseOfficerName]);

    useEffect(() => {
        checkEmail(email, false, setEmailError);
    }, [email]);

    useEffect(() => {
        checkPhoneNumber(contact, false, setContactError);
    }, [contact]);

    function checkCredentials(): boolean {
        const isCaseOfficerNameValid = checkText(caseOfficerName, false, setCaseOfficerNameError);
        const isEmailValid = checkEmail(email, false, setEmailError);
        const isContactValid = checkPhoneNumber(contact, false, setContactError);

        return isCaseOfficerNameValid && isEmailValid && isContactValid;
    }

    /* **************************************** Create ********************************* */
    const handleCreateCaseOfficerDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentials()) {
            setLoading(true);
            const data = await dischargeConditionContactDetailCreateUpdateAPI(Number(selectedDischargeCondition?.id), caseOfficerName, contact, email);
            setLoading(false);

            if (data.statusCode === 200) {
                dischargeConditionDataGet();
                handleCloseCaseOfficerDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Case officer details added successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: `Failed`,
                        detail: `There was an error creating case officer's detail.`,
                        life: 3000
                    });
                }
            }
        }
    }
    /* **************************************** Create ********************************* */

    /* **************************************** Update ********************************* */
    const handleUpdateCaseOfficerDetail = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentials()) {
            setLoading(true);
            const data = await dischargeConditionContactDetailCreateUpdateAPI(Number(selectedDischargeCondition?.id), caseOfficerName, contact, email);
            setLoading(false);

            if (data.statusCode === 200) {
                dischargeConditionDataGet();
                handleCloseCaseOfficerDetailModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Case officer details updated successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: `Failed`,
                        detail: `There was an error updating case officer's detail.`,
                        life: 3000
                    });
                }
            }
        }
    }

    const handleDeleteCaseOfficerDetail = () => {
        const detailId = selectedDischargeCondition?.id;
        confirmDialog({
            message: 'Are you sure you want to delete the case officer details?',
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteCaseOfficerDetail(detailId!),
            dismissableMask: true,
            resizable: false,
            draggable: false,
        });
    }

    const deleteCaseOfficerDetail = async (detailId: number) => {
        setDeleteLoading(true);

        const data = await dischargeConditionContactDetailDeleteAPI(Number(detailId));
        setDeleteLoading(false);

        if (data.statusCode === 200) {
            dischargeConditionDataGet();
            handleCloseCaseOfficerDetailModal();

            if (toast.current) {
                toast.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Case officer details deleted successfully.`,
                    life: 3000,
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: `Failed`,
                    detail: `There was an error deleting case officer's detail.`,
                    life: 3000
                });
            }
        }
    }


    /* **************************************** Update ********************************* */
    const caseOfficerDetailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;Case officer detail
            </h5>

            {dataState === 'Edit' ? (
                <React.Fragment>
                    {isPermission_delete_case_officer ? (
                        <React.Fragment>
                            {deleteLoading ? (
                                <TableActionLoader className="is_modal_loader" />
                            ) : (
                                <React.Fragment>
                                    <button type="button" className="data_delete_btn p-ripple"
                                        onClick={handleDeleteCaseOfficerDetail}>
                                        <i className="bi bi-trash3"></i>
                                        <Ripple />
                                    </button>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    ) : (
                        <button type="button" className="close_modal_btn p-ripple"
                            onClick={handleCloseCaseOfficerDetailModal}>
                            <i className="bi bi-x-circle"></i>
                            <Ripple />
                        </button>
                    )}
                </React.Fragment>
            ) : (
                <button type="button" className="close_modal_btn p-ripple"
                    onClick={handleCloseCaseOfficerDetailModal}>
                    <i className="bi bi-x-circle"></i>
                    <Ripple />
                </button>
            )}
        </div>
    );

    const caseOfficerDetailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseCaseOfficerDetailModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateCaseOfficerDetail : handleUpdateCaseOfficerDetail}
                loading={loading}
                className="custom_btn primary"
                disabled={(dataState === 'Edit' && !caseOfficerDetailUpdateHasChanges) || (dataState === 'Add' && caseOfficerName === '' && email === '' && contact === '')}
            />
        </div>
    );
    /* *************************************************************************** */

    /* ***************************************************** For followup *************************************************** */
    useEffect(() => {
        checkText(followupNote, false, setErrorFollowupNote);
    }, [followupNote]);

    useEffect(() => {
        if (selectedFollowupData && selectedFollowupId) {
            if (followupNote !== selectedFollowupData?.note) {
                setFollowUpUpdateHasChanges(true);
            } else {
                setFollowUpUpdateHasChanges(false);
            }
        }
    }, [selectedFollowupData, selectedFollowupId, followupNote]);

    const handleAddFollowup = () => {
        setDataState('Add');
        setShowFollowupModal(true);
    }

    const handleEditFollowup = (followUp: DischargeConditionFollowup) => {
        setDataState('Edit');
        setShowFollowupModal(true);
        setSelectedFollowupData(followUp);

        setSelectedFollowupId(followUp.id);
        setFollowupNote(followUp.note);
    }

    const handleCloseFollowupModal = () => {
        setShowFollowupModal(false);
        handleClearFollowUpFields();
    }

    const handleClearFollowUpFields = () => {
        setFollowupNote('');
        setSelectedFollowupId(null);
        setErrorFollowupNote('');
    }

    function checkCredentialFollowup(): boolean {
        const isFollowupNoteValid = checkText(followupNote, true, setErrorFollowupNote);

        return isFollowupNoteValid;
    }

    /* **************************************** Create ********************************* */
    const handleCreateFollowup = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialFollowup()) {
            setLoading(true);
            const data = await dischargeConditionFollowupCreateAPI(Number(selectedDischargeCondition?.id), followupNote);
            setLoading(false);

            if (data.statusCode === 200) {
                dischargeConditionDataGet();
                handleCloseFollowupModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Followup note added successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error creating followup.',
                        detail: 'There was an error creating followup note.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* **************************************** Create ********************************* */

    /* **************************************** Update ********************************* */
    const handleUpdateFollowup = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialFollowup()) {
            setLoading(true);
            const data = await dischargeConditionFollowupUpdateAPI(Number(selectedFollowupId), followupNote);
            setLoading(false);

            if (data.statusCode === 200) {
                dischargeConditionDataGet();
                handleCloseFollowupModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Followup note updated successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error updating followup.',
                        detail: 'There was an error updating followup note.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* **************************************** Update ********************************* */

    /* **************************************** Delete ********************************* */
    const handleDeleteData = (followUpId: number): void => {
        confirmDialog({
            message: 'Are you sure you want to delete the followup note?',
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteData(followUpId),
        });
    }

    const deleteData = async (followUpId: number) => {
        setFollowUpDeleteLoadingId(followUpId);
        const data = await dischargeConditionFollowupDeleteAPI(followUpId);

        setFollowUpDeleteLoadingId(null);
        if (data.statusCode === 200) {
            dischargeConditionDataGet();
            handleCloseFollowupModal();

            if (toast.current) {
                toast.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Followup note deleted successfully.`,
                    life: 3000,
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'Error deleting followup note.',
                    life: 3000
                });
            }
        }
    }
    /* **************************************** Delete ********************************* */

    /* ***************************************************** For followup *************************************************** */

    const followupModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState}&nbsp;Followup
            </h5>
            {dataState === 'Edit' ? (
                <React.Fragment>
                    {followUpDeleteLoadingId === selectedFollowupId ? (
                        <TableActionLoader className="is_modal_loader" />
                    ) : (
                        <React.Fragment>
                            {isPermission_delete_follow_up && (
                                <button type="button" className="close_modal_btn p-ripple"
                                    onClick={() => handleDeleteData(selectedFollowupId!)}>
                                    <i className="bi bi-trash3"></i>
                                    <Ripple />
                                </button>
                            )}
                        </React.Fragment>
                    )}
                </React.Fragment>
            ) : (
                <button type="button" className="close_modal_btn p-ripple"
                    onClick={handleCloseFollowupModal}>
                    <i className="bi bi-x-circle"></i>
                    <Ripple />
                </button>
            )}
        </div>
    );

    const followupModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseFollowupModal}
            />

            <Button
                label={loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}
                onClick={dataState === 'Add' ? handleCreateFollowup : handleUpdateFollowup}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !followUpUpdateHasChanges}
            />
        </div>
    );
    /* *************************************************************************** */


    /* ******************************* For table ******************************* */
    const getRowClassName = () => {
        return 'table_data_row';
    };

    const conNoBody = (rowData: DischargeConditions) => {
        const status = rowData.status;
        let statusColor = '';

        if (status === 'Approved') {
            statusColor = '#7FF2B3';
        } else if (status === 'Application submitted') {
            statusColor = '#FBFF00';
        } else if (status === 'Pending') {
            statusColor = '#FFC300';
        } else if (status === 'Informative') {
            statusColor = '#DDDDDD';
        }

        return (
            <div className="number_container" style={{ backgroundColor: statusColor }}>
                {rowData.condition_no}
            </div>
        )
    }

    const drawingFileBody = (rowData: DischargeConditions) => {
        return (
            <span className="d-flex justify-content-center">
                {rowData.drawing_file != null ? (
                    <button className="doc_view_btn p-ripple"
                        onClick={() => handleViewDocument(baseURL + rowData.drawing_file!)}>
                        <Ripple />
                        <i className="bi bi-file-earmark-pdf"></i>
                    </button>
                ) : (
                    <span className="text-secondary text-center">--</span>
                )}
            </span>
        )
    }
    /* *************************************************************************** */


    /* ****************************** For view  file ***************************** */
    const handleViewDocument = (document: string) => {
        setDrawingFileUrl(document);
        setShowDocumentViewModal(true);
    }

    const handleCloseDocumentViewModal = () => {
        setShowDocumentViewModal(false);
    };
    /* *************************************************************************** */


    /* **************************** Common functions ***************************** */
    const goBack = () => {
        navigate(-1);
        goToTop();
    };
    /* *************************************************************************** */


    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {loadingPage ? (
                    <PageLoader />
                ) : error ? (
                    <ErrorPage errorMessage={error} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-2)}>
                                    {projectData.job_number} : {projectData.address}
                                </li>
                                <li className="page_breadcrumb_item has_child">
                                    {projectData.folder}
                                </li>
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                    {projectData.feature_name}
                                </li>
                                <li className="page_breadcrumb_item active">
                                    Details
                                </li>
                            </ul>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_main_content_section mt-sm-4">
                            {selectedDischargeCondition ? (
                                <React.Fragment>
                                    <DataTable
                                        value={[selectedDischargeCondition]}
                                        size="small"
                                        rows={10}
                                        rowsPerPageOptions={[5, 10, 25, 50]}
                                        tableStyle={{ minWidth: '50rem' }}
                                        className="page_table table_auto_height  p-0 p-sm-2"
                                        rowHover
                                        rowClassName={getRowClassName}
                                    >
                                        <Column
                                            header="Con. No."
                                            headerClassName="text_purple"
                                            body={conNoBody}
                                            style={{ width: '8%' }}
                                            frozen
                                        ></Column>

                                        <Column
                                            header="Condion Type"
                                            headerClassName="text_purple"
                                            field="type"
                                            body={(rowData: DischargeConditions) => (
                                                <span className="text_bold text_no_wrap">
                                                    {rowData.type ? rowData.type : '---'}
                                                </span>
                                            )}
                                            style={{ width: '15%' }}
                                        ></Column>

                                        <Column
                                            header="Short Description"
                                            headerClassName="text_purple"
                                            field="description"
                                            body={(rowData: DischargeConditions) => (
                                                <span>
                                                    {rowData.short_description ? rowData.short_description : '--'}
                                                </span>
                                            )}
                                            style={{ width: '30%' }}
                                        ></Column>

                                        <Column
                                            header="Ref. No."
                                            headerClassName="text_purple"
                                            field="reference_no"
                                            body={(rowData: DischargeConditions) =>
                                                <span className="text_no_wrap">
                                                    {rowData.reference_no ? rowData.reference_no : '---'}
                                                </span>
                                            }
                                            style={{ width: '14%' }}
                                        ></Column>

                                        <Column
                                            header="Validation"
                                            headerClassName="text_purple"
                                            field="validation_date"
                                            body={(rowData: DischargeConditions) => (
                                                <span className="text_no_wrap">
                                                    {rowData.validation_date ? rowData.validation_date : '---'}
                                                </span>
                                            )}
                                            style={{ width: '14%' }}
                                        ></Column>

                                        <Column
                                            header="Decision"
                                            headerClassName="text_purple"
                                            field="decision_date"
                                            body={(rowData: DischargeConditions) => (
                                                <span className="text_no_wrap">
                                                    {rowData.decision_date ? rowData.decision_date : '---'}
                                                </span>
                                            )}
                                            style={{ width: '14%' }}
                                        ></Column>

                                        <Column
                                            header="DWG"
                                            headerClassName="text_purple"
                                            alignHeader={"center"}
                                            body={drawingFileBody}
                                            style={{ width: '5%' }}
                                        ></Column>
                                    </DataTable>

                                    <div className="view_data_area">
                                        {selectedDischargeCondition?.description && (
                                            <div className="description_area">
                                                <label htmlFor="description" className="title_label text_purple mb-2">Description</label>

                                                <p>{selectedDischargeCondition?.description}</p>
                                            </div>
                                        )}

                                        <label htmlFor="caseOfficerDetail" className="title_label text_purple mb-2">Case officer details</label>
                                        <div className="table-responsive">
                                            <table className="table table-bordered view_data_table">
                                                <tr className="view_data_table_row">
                                                    <th>Name : </th>
                                                    <td className="edit_data_row">
                                                        {selectedDischargeCondition?.case_officer_name !== null ? (
                                                            <span>{selectedDischargeCondition.case_officer_name}</span>
                                                        ) : (
                                                            <span className="text-secondary">---</span>
                                                        )}
                                                    </td>

                                                    {!isShared && (
                                                        <td rowSpan={3} className="my-auto">
                                                            <div>
                                                                {(selectedDischargeCondition?.case_officer_name !== null
                                                                    || selectedDischargeCondition?.email !== null
                                                                    || selectedDischargeCondition?.contact_no !== null) ? (

                                                                    <React.Fragment>
                                                                        {isPermission_edit_case_officer && (
                                                                            <button className="data_edit_button p-ripple"
                                                                                onClick={handleEditCaseOfficerDetail}>
                                                                                <i className="bi bi-pencil"></i>
                                                                                <Ripple />
                                                                            </button>
                                                                        )}
                                                                    </React.Fragment>
                                                                ) : (
                                                                    <React.Fragment>
                                                                        {isPermission_add_case_officer && (
                                                                            <button className="data_edit_button p-ripple"
                                                                                onClick={handleAddCaseOfficerDetail}>
                                                                                <i className="bi bi-plus-lg"></i>
                                                                                <Ripple />
                                                                            </button>
                                                                        )}
                                                                    </React.Fragment>
                                                                )}
                                                            </div>
                                                        </td>
                                                    )}
                                                </tr>
                                                <tr className="view_data_table_row">
                                                    <th>Email :</th>
                                                    <td>
                                                        {selectedDischargeCondition?.email !== null ? (
                                                            <Link to={`mailto:${selectedDischargeCondition.email}`}>{selectedDischargeCondition.email}</Link>
                                                        ) : (
                                                            <span className="text-secondary">---</span>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr className="view_data_table_row">
                                                    <th>Phone :</th>
                                                    <td>
                                                        {selectedDischargeCondition?.contact_no !== null ? (
                                                            <Link to={`tel:${selectedDischargeCondition.contact_no}`}>{selectedDischargeCondition.contact_no}</Link>
                                                        ) : (
                                                            <span className="text-secondary">---</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            </table>

                                            <table className="table table-bordered view_data_table mt-3 mb-3">
                                                <tr className="view_data_table_row">
                                                    <th>Decision notice : </th>
                                                    <td>
                                                        {selectedDischargeCondition?.decision_notice_file !== null ? (
                                                            <div className="document_show p-ripple"
                                                                onClick={() => handleViewDocument(baseURL + selectedDischargeCondition.decision_notice_file!)}>
                                                                <i className="bi bi-file-earmark-pdf"></i>
                                                                <h6>Decision notice.pdf</h6>
                                                                <Ripple />
                                                            </div>
                                                        ) : (
                                                            <span className="text-secondary">---</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            </table>

                                            {selectedDischargeCondition?.discharge_condition_followup.length > 0 ? (
                                                selectedDischargeCondition.discharge_condition_followup.map((followup, index) => (
                                                    <table key={followup.id} className="table table-bordered view_data_table mt-2">
                                                        <tr className="view_data_table_row">
                                                            <th className="followup_note_head">Followup {index + 1} : </th>
                                                            <td className="followup_note_area">
                                                                {isPermission_edit_follow_up && !isShared && (
                                                                    <button className="data_edit_button p-ripple"
                                                                        onClick={() => handleEditFollowup(followup)}>
                                                                        <i className="bi bi-pencil"></i>
                                                                        <Ripple />
                                                                    </button>
                                                                )}
                                                                {followup.note}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                ))
                                            ) : (
                                                <table className="table table-bordered view_data_table mt-3">
                                                    <tr className="view_data_table_row">
                                                        <td className="text-secondary text-center">
                                                            No follow-up note found. {!isShared ? 'Click the Add button to create a follow-up note.' : ''}
                                                        </td>
                                                    </tr>
                                                </table>
                                            )}

                                            {isPermission_add_follow_up && !isShared && (
                                                <button className={`add_data_btn p-ripple mt-3`} onClick={handleAddFollowup}>
                                                    <i className={`bi bi-plus-circle`}></i>
                                                    <span>Add followup</span>
                                                    < Ripple />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </React.Fragment>

                            ) : (
                                <NoDataCreated
                                    message={`No ${projectData.feature_name} document found.`}
                                />
                            )}
                        </div>
                    </div>
                )}
            </div >


            {/* Follow up modal */}
            <Dialog
                visible={showFollowupModal}
                header={followupModalHeader}
                footer={followupModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_md"
                onHide={handleCloseFollowupModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                        <div className="row">
                            <div className="col-12">
                                <Textarea
                                    id="followupNote"
                                    label="Add note"
                                    labelHtmlFor="description"
                                    required={true}
                                    value={followupNote}
                                    placeholder="Enter your note"
                                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setFollowupNote(e.target.value)}
                                    error={errorFollowupNote}
                                    formGroupClassName="mb-2"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>


            {/* Case officer detail modal */}
            <Dialog
                visible={showCaseOfficerDetailModal}
                header={caseOfficerDetailModalHeader}
                footer={caseOfficerDetailModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseCaseOfficerDetailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                        <div className="row">
                            <div className="col-12">
                                {/* Case officer name */}
                                <div className="col-12">
                                    <TextInput
                                        id="caseOfficerName"
                                        label="Case officer name"
                                        labelHtmlFor="caseOfficerName"
                                        required={false}
                                        value={caseOfficerName}
                                        placeholder="Case officer name"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCaseOfficerName(e.target.value)}
                                        error={caseOfficerNameError}
                                    />
                                </div>

                                {/* Email */}
                                <div className="col-12">
                                    <TextInput
                                        id="email"
                                        label="Email"
                                        labelHtmlFor="email"
                                        required={false}
                                        value={email}
                                        keyFilter={"email"}
                                        placeholder="Email"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                        error={emailError}
                                    />
                                </div>

                                {/* Contact */}
                                <div className="col-12">
                                    <TextInput
                                        id="contact"
                                        label="Contact"
                                        labelHtmlFor="contact"
                                        required={false}
                                        value={contact}
                                        placeholder="Contact"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContact(e.target.value)}
                                        error={contactError}
                                        formGroupClassName="mb-2"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>


            {/* Document view modal */}
            <DocumentViewModal
                isOpen={showDocumentViewModal}
                onClose={handleCloseDocumentViewModal}
                fileUrl={drawingFileUrl}
            />
        </React.Fragment>
    )
}

export default DischargeConditionDetail;